import React from "react";
import { Mic } from "lucide-react";
import { SearchMode } from "../types/drawerTypes";
import { AIChatVersionIndicator } from "../../AIChatSelector/AIChatSelector";

interface FooterStatusProps {
  searchMode: SearchMode;
  selectedPlan: any;
  selectedPlanDetail: any;
  isLoading: boolean;
  isVoiceRecording: boolean;
  isTranscribing: boolean;
  transcriptionError: string | null;
  voiceRecorderError: string | null;
}

const FooterStatus: React.FC<FooterStatusProps> = ({
  searchMode,
  selectedPlan,
  selectedPlanDetail,
  isLoading,
  isVoiceRecording,
  isTranscribing,
  transcriptionError,
  voiceRecorderError,
}) => {
  return (
    <div className="px-4 py-1 bg-white border-t border-slate-100 flex items-center justify-between text-[9px] text-slate-400 uppercase tracking-wider">
      <div className="flex items-center gap-3">
        <span>
          {searchMode === "current" && selectedPlanDetail
            ? `${selectedPlan?.propertyName} - ${selectedPlanDetail.planName}`
            : searchMode === "property" && selectedPlan
            ? selectedPlan.propertyName
            : searchMode === "global"
            ? "All Properties"
            : "No Property Selected"}
        </span>
        <AIChatVersionIndicator className="transform scale-[0.8] origin-left normal-case tracking-normal" />
      </div>
      <span className="flex items-center gap-1">
        {isLoading ? (
          <>
            <div className="animate-spin rounded-full h-2 w-2 border border-slate-400 border-t-transparent"></div>
            <span>Thinking</span>
          </>
        ) : isVoiceRecording ? (
          <span className="flex items-center gap-1 text-red-600 animate-pulse">
            <Mic className="w-3 h-3" />
            Recording...
          </span>
        ) : isTranscribing ? (
          <span className="flex items-center gap-1 text-orange-600">
            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-orange-600"></div>
            Transcribing...
          </span>
        ) : transcriptionError || voiceRecorderError ? (
          <div className="mt-2 px-1">
            <p className="text-xs text-red-600">
              {transcriptionError || voiceRecorderError}
            </p>
          </div>
        ) : (
          "Ready"
        )}
      </span>
    </div>
  );
};

export default FooterStatus;
